<div class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <span>Jam Pengaktifan (WIB)</span>
        <button class="close-button" (click)="closeModal()"><img src="assets/icons/close.svg" alt=""></button>
      </div>

      <div class="time-columns">
        <!-- Hours Column -->
        <div class="time-column" #hoursContainer (scroll)="onHourScroll()">
          <div class="time-spacer"></div>
          @for (hour of data.hour ; track hour) {
            <div class="time-item"
                 [class.selected]="selectedHour === hour">
              {{ hour }}
            </div>
          }
          <div class="time-spacer"></div>
        </div>

        <!-- Minutes Column -->
        <div class="time-column" #minutesContainer (scroll)="onMinuteScroll()">
          <div class="time-spacer"></div>
          @for (minute of data.minutes; track minute) {
            <div class="time-item"
                 [class.selected]="selectedMinute === minute">
              {{ minute }}
            </div>
          }
          <div class="time-spacer"></div>
        </div>

        <!-- AM/PM Column -->
        <div class="time-column period-column" #periodContainer (scroll)="onPeriodScroll()">
          <div class="time-spacer"></div>
          @for (period of data.periods; track period) {
            <div class="time-item"
                 [class.selected]="selectedPeriod === period">
              {{ period }}
            </div>
          }
          <div class="time-spacer"></div>
        </div>

        <!-- Selection Indicator -->
        <div class="selection-indicator"></div>
      </div>

      <button class="select-button" (click)="selectTime()">
        Pilih
      </button>
    </div>
  </div>